import React from "react";
import ContactDetailsForm from "../ContactDetailsForm/ContactDetailsForm";

const ContactFormLayout = () => {
  return <ContactDetailsForm />;
};

export default ContactFormLayout;
